/**
 * Converts the given file to a Base64 string
 */
export const fileToString = (file: Blob): Promise<string> => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();

    // Read the file
    reader.readAsDataURL(file);

    // On load
    reader.onload = () => {
      if (typeof reader.result !== "string") {
        return reject("The image could not be converted to a string");
      }

      resolve(reader.result);
    };
    // On error
    reader.onerror = error => reject(error);
  });
};
